import { ReferenceDataEstablishment, ReferenceDataEstablishmentDetail, ReferenceDataImplantation } from "../model/reference-data";

export interface EtablissementDto {
	id: string;
	fase: number;
	fasePO: number;
	denomination: string;
}

export const EtablissementDtoMapper = {
	toDomain: (dto: EtablissementDto): ReferenceDataEstablishment => {
		return {
			id: dto.id,
			establishmentFase: dto.fase,
			educationAuthorityFase: dto.fasePO,
			establishmentName: dto.denomination,
		} as ReferenceDataEstablishment;
	}
};

export interface EtablissementDetailDto {
	id: string;
	fase: number;
	fasePO: number;
	implantations: Implantation[];
	denomination: string;
}

export interface Implantation {
	id: string;
	fase: number;
	niveauEnseignement: string;
}

export const EtablissementDetailDtoMapper = {
	toDomain: (dto: EtablissementDetailDto): ReferenceDataEstablishmentDetail => {
		return {
			id: dto.id,
			establishmentFase: dto.fase,
			educationAuthorityFase: dto.fasePO,
			establishmentName: dto.denomination,
			implantations: dto.implantations.map((implantation) => {
				return {
					id: implantation.id,
					implantationFase: implantation.fase,
					level: implantation.niveauEnseignement,
				} as ReferenceDataImplantation;
			}),
		} as ReferenceDataEstablishmentDetail;
	}
};

